module.exports = __webpack_public_path__ + "static/media/Logout.b938ee3b.svg";